var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAlerta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-alerta",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.995,
    height: 162.995,
    viewBox: "0 0 162.995 162.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5975",
    "data-name": "Trazado 5975",
    d: "M445,123.284l-23.449-5.331V98.51a2.831,2.831,0,0,0-2.482-2.765l-53.34-7.16v0l-53.345,7.16a2.832,2.832,0,0,0-2.476,2.762V117.95l-23.45,5.331A2.8,2.8,0,0,0,284.231,126v39.056c0,33.608,21.26,63.772,53.543,75.968l27.954,10.56h0l27.957-10.56c32.281-12.194,53.54-42.358,53.54-75.968V126A2.8,2.8,0,0,0,445,123.284Z",
    transform: "translate(-284.231 -88.586)",
    fill: "#0c3273"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9065",
    "data-name": "Grupo 9065",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985",
    "data-name": "Grupo 8985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5907",
    "data-name": "Trazado 5907",
    d: "M309.908,98.509V117.95l-23.45,5.331A2.8,2.8,0,0,0,284.231,126v39.056c0,33.608,21.26,63.772,53.543,75.968l27.954,10.56V88.588l-53.345,7.16A2.832,2.832,0,0,0,309.908,98.509Z",
    transform: "translate(-284.231 -88.586)",
    fill: "#1148a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5908",
    "data-name": "Trazado 5908",
    d: "M390.231,251.581l27.957-10.56c32.281-12.194,53.54-42.358,53.54-75.968V126a2.8,2.8,0,0,0-2.227-2.718l-23.449-5.331V98.51a2.831,2.831,0,0,0-2.482-2.765l-53.34-7.16Z",
    transform: "translate(-308.734 -88.586)",
    fill: "#0c3273"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Exclusi\\xF3n_1",
    "data-name": "Exclusi\\xF3n 1",
    d: "M50.253,100.507a50.018,50.018,0,0,1-28.1-8.582A50.4,50.4,0,0,1,3.949,69.814,50.187,50.187,0,0,1,8.582,22.156,50.4,50.4,0,0,1,30.692,3.949,50.188,50.188,0,0,1,78.351,8.582a50.4,50.4,0,0,1,18.207,22.11,50.187,50.187,0,0,1-4.633,47.658,50.4,50.4,0,0,1-22.11,18.207A49.939,49.939,0,0,1,50.253,100.507Zm-.065-77.474L23.033,77.343h54.31ZM52,70.1H48.378V66.481H52V70.1Zm0-7.242H48.378v-18.1H52v18.1Z",
    transform: "translate(31.073 30.418)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlerta);
export default __webpack_public_path__ + "static/media/ico-alerta.515beb637562fce981c841fecbe1a38b.svg";
export { ForwardRef as ReactComponent };